import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Text from '../../../shared/components/basic/Text';
import SelectorTienda from '../../../shared/components/dataEntry/SelectorTienda.dataentry';
import Flex from '../../../shared/components/basic/Flex';

export default function FiltrosPedidolc({
  selectedTienda, proveedores, selectedProveedor, onChangeProveedor, onChangeTienda, loadingProveedores,
}) {
  const permisos = useSelector(state => state.auth.permisos);

  const selectorTienda = (
    <div className="selector-pedidoslc">
      <Text
        fontSize="16px"
        marginRight="8px"
      >
        Tienda:
      </Text>
      {' '}
      <SelectorTienda
        size="large"
        permisoOtrasTiendas={false}
        style={{ minWidth: '184px', width: '200px', textTransform: 'capitalize' }}
        loading={false}
        value={selectedTienda || null}
        onChange={(value) => { onChangeTienda(value); }}
      />
    </div>
  );
  const selectorProveedor = (
    <div className="selector-pedidoslc">
      <Text
        marginRight="8px"
        fontSize="16px"
      >
        {' '}
        Proveedor:
      </Text>
      {' '}
      <Select
        showSearch
        loading={loadingProveedores}
        size="large"
        style={{ minWidth: '184px', width: '200px', textTransform: 'capitalize' }}
        value={selectedProveedor || undefined}
        placeholder="Cargando Proveedores"
        onChange={(value) => { onChangeProveedor(value); }}
        optionFilterProp="label"
      >
        {proveedores.sort((a, b) => (a.nombre.toLowerCase() <= b.nombre.toLowerCase() ? -1 : 1)).map(e => <Select.Option style={{ textTransform: 'capitalize' }} value={e.id} label={e.nombre.toLowerCase()}>{e.nombre.toLowerCase()}</Select.Option>)}
      </Select>
    </div>
  );

  return (
    <Flex justifyContent="space-between" width="100%">
      {selectorProveedor}
      {selectorTienda}
    </Flex>
  );
}

FiltrosPedidolc.propTypes = {
  proveedores: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, nombre: PropTypes.string })).isRequired,
  selectedProveedor: PropTypes.number.isRequired,
  selectedTienda: PropTypes.number,
  loadingProveedores: PropTypes.bool.isRequired,
  onChangeTienda: PropTypes.func.isRequired,
  onChangeProveedor: PropTypes.func.isRequired,
};
FiltrosPedidolc.defaultProps = {
  selectedTienda: null,
};
